<template>
    <div v-show="visible">
        <el-dialog
            title="订单详情"
            :close-on-click-modal="false"
            :visible.sync="visible"
            width="960px"
            :before-close="dialogClose">
            <div v-loading="loading" element-loading-text="加载中..." class="detail-body">
                <div class="section-title">订单信息</div>
                <el-descriptions
                    class="order-descriptions"
                    :column="2"
                    border
                    size="medium"
                    :labelStyle="descLabelStyle"
                    :contentStyle="descContentStyle">
                    <el-descriptions-item label="商户订单号" :span="2" :labelStyle="getLabelStyle('商户订单号')">{{ displayVal(detail.orderId) }}</el-descriptions-item>
                    <!-- <el-descriptions-item label="学校ID">{{ displayVal(detail.deptId) }}</el-descriptions-item>
                    <el-descriptions-item label="优惠券ID">{{ displayVal(detail.couponId) }}</el-descriptions-item> -->
                    <el-descriptions-item label="家长姓名" :labelStyle="getLabelStyle('家长姓名')">{{ displayVal(detail.parentName) }}</el-descriptions-item>
                    <el-descriptions-item label="孩子姓名" :labelStyle="getLabelStyle('孩子姓名')">{{ displayVal(detail.childName) }}</el-descriptions-item>
                    <!-- <el-descriptions-item label="智慧平台学生ID">{{ displayVal(detail.studentId) }}</el-descriptions-item> -->
                    <el-descriptions-item label="孩子班级" :labelStyle="getLabelStyle('孩子班级')">{{ displayVal(detail.childClassName) }}</el-descriptions-item>
                    <!-- <el-descriptions-item label="智慧平台班级ID">{{ displayVal(detail.classId) }}</el-descriptions-item>
                    <el-descriptions-item label="会员产品ID">{{ displayVal(detail.productId) }}</el-descriptions-item> -->
                    <el-descriptions-item label="商品类型" :labelStyle="getLabelStyle('商品类型')">{{ productTypeLabel(detail.productType) || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="购买类型" :labelStyle="getLabelStyle('购买类型')">{{ buyDateTypeLabel(detail.buyDateType) || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="产品金额(元)" :labelStyle="getLabelStyle('产品金额(元)')">{{ formatAmount(detail.productAmount) || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="优惠金额(元)" :labelStyle="getLabelStyle('优惠金额(元)')">{{ formatAmount(detail.couponAmount) || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="邮费金额(元)" :labelStyle="getLabelStyle('邮费金额(元)')">{{ formatAmount(detail.expressAmount) || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="支付金额(元)" :labelStyle="getLabelStyle('支付金额(元)')">{{ formatAmount(detail.amount) || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="校徽数量" :labelStyle="getLabelStyle('校徽数量')">{{ displayVal(detail.count) }}</el-descriptions-item>
                    <el-descriptions-item label="卡号" :labelStyle="getLabelStyle('卡号')">{{ displayVal(detail.cardNo) }}</el-descriptions-item>
                    <el-descriptions-item label="预支付交易会话标识" :span="2" :labelStyle="getLabelStyle('预支付交易会话标识')">{{ displayVal(detail.prepayId) }}</el-descriptions-item>
                    <el-descriptions-item label="状态" :labelStyle="getLabelStyle('状态')">{{ statusLabel(detail.status) || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="预支付交易时间" :labelStyle="getLabelStyle('预支付交易时间')">{{ formatGmtCreate(detail.timeStamp) || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="支付方式" :labelStyle="getLabelStyle('支付方式')">{{ payTypeLabel(detail.payType) || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="支付时间" :labelStyle="getLabelStyle('支付时间')">{{ formatGmtCreate(detail.payTime) || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="交易订单号" :span="2" :labelStyle="getLabelStyle('交易订单号')">{{ displayVal(detail.transactionId) }}</el-descriptions-item>
                    <el-descriptions-item label="商户订单号(账单)" :span="2" :labelStyle="getLabelStyle('商户订单号(账单)')">{{ displayVal(detail.partyOrderId) }}</el-descriptions-item>
                    <el-descriptions-item label="全局流水号" :span="2" :labelStyle="getLabelStyle('全局流水号')">{{ displayVal(detail.hfSeqId) }}</el-descriptions-item>
                    <el-descriptions-item label="校徽是否有孩子头像" :labelStyle="getLabelStyle('校徽是否有孩子头像')">{{ badgeAvatarLabel(detail.badgeAvatar) || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="校徽邮寄方式" :labelStyle="getLabelStyle('校徽邮寄方式')">{{ expressTypeLabel(detail.expressType) || '-' }}</el-descriptions-item>
                    <el-descriptions-item label="蓝底1寸证件照" :labelStyle="getLabelStyle('蓝底1寸证件照')">
                        <template v-if="detail.badgeBluePhotoUrl">
                            <el-button type="text" size="small" @click="previewImage(detail.badgeBluePhotoUrl, '蓝底1寸证件照')">查看图</el-button>
                        </template>
                        <span v-else>-</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="校徽原图照" :labelStyle="getLabelStyle('校徽原图照')">
                        <template v-if="detail.badgePhotoUrl">
                            <el-button type="text" size="small" @click="previewImage(detail.badgePhotoUrl, '校徽原图照')">查看图</el-button>
                        </template>
                        <span v-else>-</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="告知书" :labelStyle="getLabelStyle('告知书')">
                        <template v-if="detail.signImageUrl">
                            <el-button type="text" size="small" @click="previewImage(detail.signImageUrl, '告知书')">查看图</el-button>
                        </template>
                        <span v-else>-</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="联系地址" :span="2" :labelStyle="getLabelStyle('联系地址')">{{ displayVal(detail.contactAddress) }}</el-descriptions-item>
                    <el-descriptions-item label="联系电话" :labelStyle="getLabelStyle('联系电话')">{{ displayVal(detail.contactPhone) }}</el-descriptions-item>
                    <el-descriptions-item label="快递号" :labelStyle="getLabelStyle('快递号')">{{ displayVal(detail.expressNumber || detail.expressNo) }}</el-descriptions-item>
                    <el-descriptions-item label="退款单号" :span="2" :labelStyle="getLabelStyle('退款单号')">{{ displayVal(detail.lastRefundOrderId) }}</el-descriptions-item>
                    <el-descriptions-item label="退款原因" :span="2" :labelStyle="getLabelStyle('退款原因')">{{ displayVal(detail.lastRefundReason) }}</el-descriptions-item>
                    <el-descriptions-item label="备注" :span="2" :labelStyle="getLabelStyle('备注')">{{ displayVal(detail.remark) }}</el-descriptions-item>
                    <!-- <el-descriptions-item label="删除标记">{{ deleteSignLabel(detail.deleteSign) || '-' }}</el-descriptions-item> -->
                    <el-descriptions-item label="创建时间" :labelStyle="getLabelStyle('创建时间')">{{ formatGmtCreate(detail.gmtCreate) || '-' }}</el-descriptions-item>
                </el-descriptions>

                <template v-if="linkStudents.length > 0">
                    <div class="section-title">关联学生</div>
                    <el-table :data="linkStudents" border size="small" style="width: 100%;">
                        <el-table-column type="index" label="序号" width="55"></el-table-column>
                        <el-table-column
                            v-if="linkStudents.length > 1"
                            label="学生ID"
                            min-width="160"
                            :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                {{ displayVal(scope.row.studentId) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="会员期限" width="170">
                            <template slot-scope="scope">
                                {{ formatGmtCreate(scope.row.memberExpire) || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="特权描述" min-width="220" :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                {{ formatPrivilege(scope.row.privilege) || '-' }}
                            </template>
                        </el-table-column>
                    </el-table>
                </template>

                <template v-if="refundRecords.length > 0">
                    <div class="section-title">退款记录</div>
                    <el-table :data="refundRecords" border size="small" style="width: 100%;">
                        <el-table-column type="index" label="序号" width="55"></el-table-column>
                        <el-table-column prop="refundOrderId" label="退款单号" min-width="180" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column label="退款金额(元)" width="120">
                            <template slot-scope="scope">
                                {{ formatAmount(scope.row.refundAmount) || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="refundCount" label="退款校徽数量" width="100"></el-table-column>
                        <el-table-column prop="refundReason" label="退款原因" min-width="160" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column label="状态" width="80">
                            <template slot-scope="scope">
                                {{ refundStatusLabel(scope.row.status) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="退款时间" width="170">
                            <template slot-scope="scope">
                                {{ formatGmtCreate(scope.row.refundTime) || '-' }}
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="visible = false">关 闭</el-button>
            </span>
        </el-dialog>

        <!-- 图片预览弹窗 -->
        <el-dialog
            :title="photoDialogTitle"
            :visible.sync="photoDialogVisible"
            :close-on-click-modal="true"
            :append-to-body="true"
            width="480px">
            <div style="text-align:center;">
                <img :src="photoDialogUrl" style="max-width:100%;max-height:60vh;" />
            </div>
        </el-dialog>
    </div>
</template>

<script>
import http from '../../../../common/http';
import memberOrderMixin from './memberOrderMixin';

export default {
    mixins: [http, memberOrderMixin],
    data() {
        return {
            visible: false,
            loading: false,
            detail: {},
            photoDialogVisible: false,
            photoDialogUrl: '',
            photoDialogTitle: '',
            descLabelStyle: {
                whiteSpace: 'nowrap'
            },
            descContentStyle: {
                width: 'auto',
                wordBreak: 'break-all'
            }
        };
    },
    computed: {
        linkStudents() {
            const list = this.detail.linkStudents;
            if (!list) {
                return [];
            }
            return Array.isArray(list) ? list : [];
        },
        refundRecords() {
            const list = this.detail.refundRecords;
            if (!list) {
                return [];
            }
            return Array.isArray(list) ? list : [];
        }
    },
    methods: {
        /** 标签列宽按 label 字数自适应，内容区占满剩余宽度 */
        getLabelStyle(label) {
            const text = label || '';
            const charWidth = 14;
            const padding = 24;
            const width = text.length * charWidth + padding;
            return {
                width: width + 'px',
                minWidth: width + 'px',
                maxWidth: width + 'px',
                whiteSpace: 'nowrap',
                boxSizing: 'border-box'
            };
        },
        init(row) {
            this.visible = true;
            this.detail = Object.assign({}, row || {});
            if (row && row.id) {
                this.loadDetail(row.id);
            } else if (row && row.orderId) {
                this.loadDetailByOrderId(row.orderId);
            }
        },
        normalizeDetail(data) {
            if (!data) {
                return;
            }
            const order = data.order || data.memberOrder || data;
            const links = data.linkStudents || order.linkStudents || [];
            const refunds = data.refundRecords || order.refundRecords || [];
            this.detail = Object.assign({}, this.detail, order);
            this.detail.linkStudents = Array.isArray(links) ? links : [];
            this.detail.refundRecords = Array.isArray(refunds) ? refunds : [];
        },
        loadDetail(id) {
            this.loading = true;
            const url = this.memberOrderGetUrl;
            this.apiPost(url, { id }).then((res) => {
                this.loading = false;
                if (res.status === 200) {
                    const d = res.data;
                    if (d) {
                        this.normalizeDetail(d.data || d);
                    }
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
            }, (err) => {
                console.log(err);
                this.loading = false;
            });
        },
        loadDetailByOrderId(orderId) {
            this.loading = true;
            const url = this.memberOrderGetUrl;
            this.apiPost(url, { orderId }).then((res) => {
                this.loading = false;
                if (res.status === 200) {
                    const d = res.data;
                    if (d) {
                        this.normalizeDetail(d.data || d);
                    }
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
            }, (err) => {
                console.log(err);
                this.loading = false;
            });
        },
        dialogClose(done) {
            done();
        },
        previewImage(url, title) {
            this.photoDialogUrl = url || '';
            this.photoDialogTitle = title || '图片预览';
            this.photoDialogVisible = true;
        },
        refundStatusLabel(v) {
            if (v === 0 || v === '0') return '申请退款';
            if (v === 1 || v === '1') return '等待退款';
            if (v === 2 || v === '2') return '退款成功';
            return v != null && v !== '' ? String(v) : '';
        }
    }
};
</script>

<style scoped>
.detail-body {
    max-height: 65vh;
    overflow-y: auto;
}
.section-title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    margin: 16px 0 10px;
}
.section-title:first-child {
    margin-top: 0;
}
.order-descriptions >>> .el-descriptions__table {
    table-layout: auto;
    width: 100%;
}
.order-descriptions >>> .el-descriptions-item__label {
    vertical-align: top;
}
.order-descriptions >>> .el-descriptions-item__content {
    width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/page/member/order/OrderDetail.vue